import {BlankTemplate} from "./email-templates/BlankTemplate"
import {AwaitingTemplate} from "./email-templates/AwaitingTemplate"
import {PaymentIssueTemplate} from "./email-templates/PaymentIssueTemplate"
import {PaidTemplate} from "./email-templates/PaidTemplate"
import {TransferIssueTemplate} from "./email-templates/TransferIssueTemplate"
import {TransferredTemplate} from "./email-templates/TransferredTemplate"
import {CanceledTemplate} from "./email-templates/CanceledTemplate"
import {CashPickupTemplate} from "./email-templates/CashPickupTemplate"
import {AwaitingReminderTemplate} from "./email-templates/AwaitingReminderTemplate"
import {NZDSoFTemplate} from "./email-templates/NZDSoFTemplate"
import {IRTSoFTemplate} from "./email-templates/IRTSoFTemplate"

export const EmailTemplatesMixin = {
    data() {
        return {
            templates: [
                BlankTemplate,
                AwaitingTemplate,
                AwaitingReminderTemplate,
                CanceledTemplate,
                CashPickupTemplate,
                PaymentIssueTemplate,
                PaidTemplate,
                TransferIssueTemplate,
                TransferredTemplate,
                NZDSoFTemplate,
                IRTSoFTemplate,
            ],
        }
    },
}
